/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GiveawayRound = {
    /**
     * Giveaway round ID
     */
    id: string;
    /**
     * Parent giveaway type ID
     */
    giveawayTypeId: string;
    /**
     * 0=WAITING, 10=ACTIVE, 20=PICKING, 30=DONE, 40=ERROR
     */
    status: GiveawayRound.status;
    /**
     * Item to be given away
     */
    itemId: string;
    /**
     * Round number for this giveaway type
     */
    roundNumber: number;
    /**
     * Winner user ID
     */
    winnerId?: string | null;
    /**
     * When the round ends (null if WAITING)
     */
    endsAt?: string | null;
    createdAt?: string;
    updatedAt?: string;
};
export namespace GiveawayRound {
    /**
     * 0=WAITING, 10=ACTIVE, 20=PICKING, 30=DONE, 40=ERROR
     */
    export enum status {
        '_0' = 0,
        '_10' = 10,
        '_20' = 20,
        '_30' = 30,
        '_40' = 40,
    }
}

